import {Config} from "@rezonence/freewall-creator-config";
export class InfrastructureResolver {

    constructor(public readonly config: Config) {
    }
}